<template>
  <router-view />
</template>

<script>
export default {
    name: "RouteView",
};
</script>
